import { requireUser } from '~/apps/shared/permissions';
import { UserRole } from '~/apps/shared/consts';

// Pages
import PaycodeList from './pages/PaycodeList';
import SettingsAccount from './pages/SettingsAccount';
import Logout from "~/apps/shared/pages/Logout";


// Client-side routes
export const appRoutes = [
  {
    name: 'support',
    path: '/support',
    forwardTo: 'support.paycodes',
    canActivate: requireUser(),
    children: [
      {
        name: 'paycodes',
        path: '/codes?q',
        comp: PaycodeList,
        children: [
        //   {
        //     name: 'info',
        //     path: '/info/:paycodeId',
        //     comp: PaycodeInfo,
        //   },
        ],
      },
      {
        name: 'settings',
        path: '/settings',
        forwardTo: 'support.settings.account',
        comp: SettingsAccount,
        children: [
          {
            name: 'account',
            path: '/account',
            comp: SettingsAccount,
          },
          {
            name: 'logout',
            path: '/logout',
            comp: Logout,
          }
        ],
      },
    ]
  }
];
